export default __webpack_public_path__ + "static/media/METIS.95296636.svg";